import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import InlineFileCardComponent from '../components/InlineFileCard';

export const InlineFileCard = Node.create({
  name: 'inlineFileCard',
  group: 'inline',
  inline: true,
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      name: { default: '' },
      type: { default: '' },
      size: { default: 0 },
      url: { default: '' },
      date: { default: '' },
    };
  },

  parseHTML() {
    return [{ tag: 'span[node-type="inline-file-card"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { 'node-type': 'inline-file-card' }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(InlineFileCardComponent);
  },
});
